module.exports = __webpack_public_path__ + "static/img/Servicio1.75c8a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Servicio1.png
// module id = wIY1
// module chunks = 0